<template>
  <div class="suspension-box" data-aos="fade-left" data-aos-duration="1000">
    <ul>
      <li v-for="(item,index) in contact" :key="item.id" @mouseenter="activeIdx=index" @mouseleave="activeIdx=-1">
        <div class="sb-item-icon">
          <img :src="item.logo_url" alt="">
        </div>
        <el-popover
            placement="left"
            trigger="hover"
            transition="false"
            :open-delay="0"
            :close-delay="0">
          <div class="popover-content">
            <p style="line-height: 30px;">{{ item.account }}</p>
            <img v-if="item.image_url" :src="item.image_url" alt="item.image_url">
          </div>
          <div class="sb-item-text" slot="reference">
            <b>{{ item.title }}</b>
          </div>
        </el-popover>
      </li>
    </ul>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "SuspensionBox",
  data() {
    return {
      activeIdx: -1,
    }
  },
  computed: {
    ...mapState('about', ['firstContact']),

    contact() {
      return [
        {
          id: 1,
          title: '电话联系',
          account: this.firstContact.telephone || '020-0000000',
          image_url: '',
          logo_url: require('@/assets/images/phone.png')
        },
        {
          id: 2,
          title: '微信联系',
          account: '微信公众号',
          image_url: require('@/assets/images/erweima.jpg'),
          logo_url: require('@/assets/images/weixin.png')
        },
        {
          id: 3,
          title: 'QQ联系',
          account: this.firstContact.qq_num || '0000000000',
          image_url: '',
          logo_url: require('@/assets/images/qq.png')
        },
      ]
    }
  },
  mounted() {
    this.$store.dispatch('about/getContactList')
  }
}
</script>

<style scoped lang="less">
.suspension-box {
  position: fixed;
  bottom: 200px;
  right: 38px;
  background-color: #1E55AE;
  border-radius: 5px;
  z-index: 19;

  li {
    position: relative;
    border-bottom: 1px dashed #6184C6;

    &:last-child {
      border: none;
    }

    .sb-item-icon {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 46px;
      height: 46px;
    }

    .sb-item-text {
      position: absolute;
      top: 0;
      right: 0;
      height: 44px;
      width: 140px;
      border: 1px solid #1E55AE;
      background-color: white;
      border-radius: 5px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      font-size: 17px;
      line-height: 46px;
      text-align: center;
      color: #1E55AE;
      opacity: 0;

      -webkit-transition: all 0.4s;
      transition: all 0.4s;

      &:hover {
        opacity: 1;
      }
    }
  }
}
</style>

<style lang="less">
.el-popover {
  min-width: 100px;

  .popover-content {
    line-height: 0;

    img {
      height: 100px;
      width: 100px;
    }
  }
}
</style>